var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-title" },
    [
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: {
            ok: function($event) {
              return _vm.removeTask(_vm.task.id)
            },
            hidden: _vm.removeDeleteIcons
          },
          model: {
            value: _vm.showRemoveTask,
            callback: function($$v) {
              _vm.showRemoveTask = $$v
            },
            expression: "showRemoveTask"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete task?")])]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Task could not be deleted", "ok-only": "" },
          model: {
            value: _vm.showRemoveTaskErr,
            callback: function($$v) {
              _vm.showRemoveTaskErr = $$v
            },
            expression: "showRemoveTaskErr"
          }
        },
        [_c("p", [_vm._v("A deliverable must have at least one task.")])]
      ),
      _vm._v(" "),
      _vm.index == 0
        ? _c(
            "div",
            {
              staticClass:
                "az task-table-header__task exclude-outside-click cursor-pointer",
              class: _vm.getSortingClass(),
              on: {
                click: function($event) {
                  return _vm.sortTasks({
                    sortKey: "created_date",
                    deliverables: _vm.fullDeliverables
                  })
                }
              }
            },
            [
              _vm._v("\n      Tasks "),
              _c("span", { staticClass: "task-count-second" }, [
                _vm._v("(" + _vm._s(_vm.totalTasks) + ")")
              ]),
              _vm._v(" "),
              !(
                !_vm.userAbilities.editMediaCall ||
                (_vm.deliverable &&
                  _vm.deliverable.permissions &&
                  _vm.deliverable.permissions.viewOnly)
              )
                ? _c(
                    "b-button",
                    {
                      staticClass: "add-task-btn",
                      attrs: { variant: "theme" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.createTask.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v("\n        Add Task\n        "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.addingTask,
                              expression: "addingTask"
                            }
                          ],
                          staticClass:
                            "ml-2 spinner-border spinner-border-sm text-primary",
                          attrs: { role: "status" }
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading...")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("SortTaskControl")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "field-wrap" }, [
        _c("div", { on: { click: _vm.showField } }, [
          !(
            !_vm.userAbilities.editMediaCall ||
            (_vm.deliverable &&
              _vm.deliverable.permissions &&
              _vm.deliverable.permissions.viewOnly)
          )
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover",
                      modifiers: { hover: true }
                    },
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.deleteOutside,
                      expression: "deleteOutside"
                    }
                  ],
                  class:
                    "checkbox-wrap " +
                    (_vm.removeButtonClickedOnce ? "hovered" : ""),
                  style: _vm.taskStatusColor(_vm.task),
                  attrs: { title: "Delete task" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.deleteTaskClick.apply(null, arguments)
                    }
                  }
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "touch",
                  rawName: "v-touch:swipe.left",
                  value: _vm.swipeHandler("task__title__" + _vm.task.id),
                  expression: "swipeHandler('task__title__' + task.id)",
                  arg: "swipe",
                  modifiers: { left: true }
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.titleEditing,
                  expression: "!titleEditing"
                },
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover",
                  modifiers: { hover: true }
                }
              ],
              staticClass: "field-value exclude-outside-click text-hover-bg",
              class: "task__title__" + _vm.task.id,
              attrs: { title: _vm.task.title }
            },
            [
              _c(
                "span",
                {
                  staticClass: "gesture__delete__left",
                  class: _vm.showRemoveIndicatorLeft ? "active" : "",
                  style: _vm.taskStatusColor(_vm.task)
                },
                [_c("i", { staticClass: "fas fa-trash" })]
              ),
              _vm._v("\n          " + _vm._s(_vm.task.title) + "\n          "),
              _c(
                "span",
                {
                  staticClass: "gesture__delete__right",
                  class: _vm.showRemoveIndicatorRight ? "active" : "",
                  style: _vm.taskStatusColor(_vm.task)
                },
                [_c("i", { staticClass: "fas fa-trash" })]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "custom-field" }, [
            _c("input", {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.outside,
                  expression: "outside"
                },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.titleEditing,
                  expression: "titleEditing"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.task.title,
                  expression: "task.title"
                }
              ],
              ref: "customInput",
              staticClass: "form-control title-field",
              attrs: { type: "text" },
              domProps: { value: _vm.task.title },
              on: {
                change: function($event) {
                  return _vm.updateFieldValue(_vm.task)
                },
                blur: function($event) {
                  _vm.titleEditing = false
                },
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  _vm.titleEditing = false
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.task, "title", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("i", {
          staticClass: "fas toggle-task-chev",
          class: _vm.chevronClass ? "fa-chevron-down" : "fa-chevron-up",
          on: {
            click: function($event) {
              _vm.$emit("toggleTaskFields", _vm.task.id)
              _vm.chevronClass = !_vm.chevronClass
            }
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-trash" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }